<template>
    <router-link to="/apply/1" class="btn btn-cta uc">Get Started</router-link>
</template>

<script>

export default {
    name: 'HomeLeadFormButton',
}
</script>

<style>

</style>
